<template>
  <div class="sepa-add">
    <div class="top-tab" style="display: flex;align-items: flex-end;">
      <span class="text-left">分离柱管理</span>
      <span class="text-middle">/</span>
      <span class="text-right">添加子规格</span>
    </div>
    <el-form
      :model="detailList"
      :rules="rules"
      ref="detailList"
      label-position="right"
      :inline="true"
      label-width="100px"
    >
    <div style="overflow: hidden; overflow-x: auto;white-space: nowrap;">
      <el-row style="width: 1000px;">
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="填料:" prop="firstName">
            <el-input v-model="detailList.firstName" style="width: 250px;" :disabled="true"></el-input>
          </el-form-item>
        </el-col> 
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="系列:" prop="secondName">
            <el-input v-model="detailList.secondName" style="width: 250px;" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="规格:" prop="thirdName">
            <el-input v-model="detailList.thirdName" style="width: 250px;" :disabled="true" :title="detailList.thirdName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="分离柱名称:" prop="flashColumn">
            <el-input v-model="detailList.flashColumn" style="width: 250px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="选择供应商:" prop="supplierId">
            <el-select v-model="detailList.supplierId" placeholder="请选择" style="width: 250px;">
              <el-option :label="item.supplierName" :value="item.id" v-for="(item ,index) in supplierList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="最小流速:" prop="flowRate">
            <el-input v-model="detailList.flowRate" style="width: 250px;">
              <div slot="append">ml/min</div>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="最大流速:" prop="flowRateMax">
            <el-input v-model="detailList.flowRateMax" style="width: 250px;">
              <div slot="append">ml/min</div>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="类型:" prop="type">
            <el-select v-model="detailList.type" placeholder="请选择" style="width: 250px;">
                <el-option label="正/反相柱" :value="2"></el-option>
                <el-option label="正相柱" :value="1"></el-option>
                <el-option label="反相柱" :value="0"></el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="柱体积:" prop="cv">
            <el-input v-model="detailList.cv" style="width: 250px;">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="最大耐压:" prop="pressure">
            <el-input v-model="detailList.pressure" style="width: 250px;">
              <div slot="append">psi</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="填料:" prop="filler">
            <el-input v-model="detailList.filler" style="width: 250px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="内径:" prop="innerDiameter">
            <el-input v-model="detailList.innerDiameter" style="width: 250px;">
              <div slot="append">mm</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
        <el-form-item label="质量:" prop="weight">
          <el-input v-model="detailList.weight" style="width: 250px;">
            <div slot="append">g</div></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="柱高度:" prop="length">
            <el-input v-model="detailList.length" style="width: 250px;">
              <div slot="append">mm</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="润柱体积:" prop="equilibriumVolume">
            <el-input v-model="detailList.equilibriumVolume" style="width: 250px;">
              <div slot="append">CV</div></el-input>
          </el-form-item>
        </el-col>
        <el-col  :span="12" style="height: 62px;">
          <el-form-item label="最小上样量:" prop="loadAmountMin">
            <el-input v-model="detailList.loadAmountMin" style="width: 250px;">
              <div slot="append">g</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="最大上样量:" prop="loadAmountMax">
            <el-input v-model="detailList.loadAmountMax" style="width: 250px;">
              <div slot="append">g</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="孔径:" prop="aperture">
            <el-input v-model="detailList.aperture" style="width: 250px;">
              <div slot="append">Å</div></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="height: 62px;">
          <el-form-item label="粒径:" prop="particleSize">
            <el-input v-model="detailList.particleSize" style="width: 250px;">
              <div slot="append">μm</div></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="deep-box" style="width: 1000px;">
            <el-col :span="12" style="position: relative;">
              <el-form-item label="拖尾因子:" prop="trailingFactorMin">
                <el-input v-model="detailList.trailingFactorMin" style="width: 110px;"></el-input>
              </el-form-item>
              <el-form-item prop="trailingFactorMax" style="position: absolute;">
                - <el-input v-model="detailList.trailingFactorMax" prop="trailingFactorMax" style="width: 110px;"></el-input>
              </el-form-item> 
            </el-col>
        <el-col :span="12">
          <el-form-item label="有效塔板数:" prop="effectivePedals">
            <el-input v-model="detailList.effectivePedals" style="width: 250px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分离度:" prop="resolution">
            <el-input v-model="detailList.resolution" style="width: 250px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="柱床尺寸:" prop="columnBedSize">
            <el-input v-model="detailList.columnBedSize" style="width: 250px;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24" style="padding-left: 385px; margin-bottom: 20px;">
        <el-form-item>
          <el-button type="primary" style="margin-right: 20px;width: 100px;" @click="addSave('detailList')">保存</el-button>
          <el-button type="primary" style="width: 100px;" @click="addRelease('detailList')">公开</el-button>
        </el-form-item>
      </el-col>
    </div>
      <el-table
        :data="subTableData"
        :header-cell-style="tableHeaderCellStyle"
        v-loading="subTableDataLoading"
      >
      <el-table-column prop="flashColumn" label="item No." align="center"> </el-table-column>
      <el-table-column prop="weight" label="Column Size(g)" align="center"> </el-table-column>
      <el-table-column prop="particleSize" label="Particle Size(μm)" align="center">
      </el-table-column>
      <el-table-column prop="aperture" label="Pore Size(Å)" align="center"> </el-table-column>
      <el-table-column prop="cv" label="CV(ml)" align="center"> </el-table-column>
      <el-table-column label="Flow Rate(ml/min)" align="center">
        <template slot-scope="scope">
          <div>{{ `${scope.row.flowRate}-${scope.row.flowRateMax}` }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="Max Pressure(psi/bar)" align="center">
        <template slot-scope="scope">
          <div>{{ `${scope.row.pressure}/${getMaxPressure(scope.row.pressure)}` }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="columnBedSize" label="Column bed sizes" align="center">
      </el-table-column>
      <el-table-column label="供应商" align="center">
        <template slot-scope="scope">
          <div>{{ supplierName(scope.row.supplierId)}}</div>
        </template>
      </el-table-column>
      <el-table-column label="Operation"  align="center" class-name="small-padding fixed-width" width="250px">
        <template slot-scope="scope">
          <el-link :underline="false" @click="handleEditDetail(scope.row)" style="margin-right: 10px; " v-if="scope.row.status === 0"
            >
            <img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>编辑</span></el-link
          >
          <el-link :underline="false" @click="handleDetail(scope.row)" style="margin-right: 10px;" v-if="scope.row.status === 1"
            >
            <img src="../../assets/imgs/edit.svg" style="width: 12px;margin-right: 5px;"><span>查看</span></el-link
          >
          <el-link :underline="false" @click="handlePublish(scope.row)" style="margin-right: 10px;" :disabled="scope.row.status === 1"
            >
            <img src="../../assets/imgs/publish.svg" style="width: 12px;margin-right: 5px;" v-if="scope.row.status === 0">
            <img src="../../assets/imgs/unpublish.svg" style="width: 12px;margin-right: 5px;" v-if="scope.row.status === 1"><span>公开</span></el-link
          >
          <el-link :underline="false" @click="handleDeleteFlashInfoById(scope.row)" 
            >
            <img src="../../assets/imgs/del.svg" style="width: 12px;margin-right: 5px;"><span>删除</span></el-link
          >
        </template>
      </el-table-column>
      </el-table>
    </el-form>
    <el-dialog :visible.sync="dialogEditFormVisible" center append-to-body @close="resetEditForm('editList')"> 
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">编辑填料</span>
        </div>
      </div>
        <el-form
        :model="editList"
        :rules="rules"
        ref="editList"
        label-position="right"
        :inline="true"
        label-width="100px"
        :disabled="disabled"
      >
        <el-row style="width: 800px;">
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="填料:" prop="firstName">
              <el-input v-model="editList.firstName" style="width: 250px;" :disabled="true"></el-input>
            </el-form-item>
          </el-col> 
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="系列:" prop="secondName">
              <el-input v-model="editList.secondName" style="width: 250px;" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="规格:" prop="thirdName">
              <el-input v-model="editList.thirdName" style="width: 250px;" :disabled="true" :title="editList.thirdName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="分离柱名称:" prop="flashColumn">
              <el-input v-model="editList.flashColumn" style="width: 250px;" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="选择供应商:" prop="supplierId">
              <el-select v-model="editList.supplierId" placeholder="请选择" style="width: 250px;">
                <el-option :label="item.supplierName" :value="item.id" v-for="(item ,index) in supplierList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="最小流速:" prop="flowRate">
              <el-input v-model="editList.flowRate" style="width: 250px;">
                <div slot="append">ml/min</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="最大流速:" prop="flowRateMax">
              <el-input v-model="editList.flowRateMax" style="width: 250px;">
                <div slot="append">ml/min</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="类型:" prop="type">
              <el-select v-model="editList.type" placeholder="请选择" style="width: 250px;">
                  <el-option label="正/反相柱" :value="2"></el-option>
                  <el-option label="正相柱" :value="1"></el-option>
                  <el-option label="反相柱" :value="0"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="柱体积:" prop="cv">
              <el-input v-model="editList.cv" style="width: 250px;">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="最大耐压:" prop="pressure">
              <el-input v-model="editList.pressure" style="width: 250px;">
                <div slot="append">psi</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="填料:" prop="filler">
              <el-input v-model="editList.filler" style="width: 250px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="内径:" prop="innerDiameter">
              <el-input v-model="editList.innerDiameter" style="width: 250px;">
                <div slot="append">mm</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
          <el-form-item label="质量:" prop="weight">
            <el-input v-model="editList.weight" style="width: 250px;">
              <div slot="append">g</div></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="柱高度:" prop="length">
              <el-input v-model="editList.length" style="width: 250px;">
                <div slot="append">mm</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="润柱体积:" prop="equilibriumVolume">
              <el-input v-model="editList.equilibriumVolume" style="width: 250px;">
                <div slot="append">CV</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="最小上样量:" prop="loadAmountMin">
              <el-input v-model="editList.loadAmountMin" style="width: 250px;">
                <div slot="append">g</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="最大上样量:" prop="loadAmountMax">
              <el-input v-model="editList.loadAmountMax" style="width: 250px;">
                <div slot="append">g</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="孔径:" prop="aperture">
              <el-input v-model="editList.aperture" style="width: 250px;">
                <div slot="append">Å</div></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 62px;">
            <el-form-item label="粒径:" prop="particleSize">
              <el-input v-model="editList.particleSize" style="width: 250px;">
                <div slot="append">μm</div></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="deep-box" style="width: 800px;">
            <el-col :span="12">
              <el-form-item label="拖尾因子:" prop="trailingFactor">
                <el-input v-model="editList.trailingFactorMin" style="width: 120px;"></el-input>
                -
                <el-input v-model="editList.trailingFactorMax" style="width: 120px;"></el-input>
              </el-form-item>
            </el-col>
          <el-col :span="12">
            <el-form-item label="有效塔板数:" prop="effectivePedals">
              <el-input v-model="editList.effectivePedals" style="width: 250px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分离度:" prop="resolution">
              <el-input v-model="editList.resolution" style="width: 250px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="柱床尺寸:" prop="columnBedSize">
              <el-input v-model="editList.columnBedSize" style="width: 250px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24" style="margin-bottom: 20px; display: flex; justify-content: center;">
          <el-form-item>
            <el-button type="primary" style="margin-right: 20px;width: 100px;" @click="save('editList')">保存</el-button>
            <el-button type="primary" style="width: 100px;" @click="release('editList')">公开</el-button>
          </el-form-item>
        </el-col>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  
  data() {
      var flashColumn = (rule, value, callback) => {
        if (value.length > 20) {
          callback(new Error('名称长度不超过20个字符'));
        } else {
          callback();
        }
      };
      var filler = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (value.length > 255) {
          callback(new Error('填料长度不超过255个字符'));
        } else {
          callback();
        }
      };
      var innerDiameter = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var cv = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var length = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (value.length > 10) {
          callback(new Error('总长不超过10个字符'));
          // 小数或整数
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else if (value <= 0) {
          callback(new Error('请输入正数'));
        } else {
          callback();
        }
      };
      var weight = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
           else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 999 ) {
              callback(new Error('小数部分不超过三位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var loadAmount = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9999 ) {
              callback(new Error('小数部分不超过四位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var pressure = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
           else {
            if (Math.trunc(value.toString().split(".")[0]) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var flowRate = (rule, value, callback) => {
        if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 99999 ) {
              callback(new Error('整数部分不超过五位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var equilibriumVolume = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 9999 ) {
              callback(new Error('整数部分不超过四位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var aperture = (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
        var columnBedSize= (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
           else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 9 ) {
              callback(new Error('小数部分不超过一位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
      var trailingFactor= (rule, value, callback) => {
        if (value === ''||value ===null) {
          callback();
        } else if (!Number(value) && Number(value) !== 0) {
          callback(new Error('请输入数字'));
        } else {
          if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
            if (Math.trunc(value) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (Math.trunc(value) <= 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          } 
          else {
            if (Math.trunc(value.toString().split(".")[0]) > 999 ) {
              callback(new Error('整数部分不超过三位'));
            } else if (value.toString().split(".")[1] > 99 ) {
              callback(new Error('小数部分不超过两位'));
            } else if (value.toString().split(".")[0] < 0) {
              callback(new Error('请输入正数'));
            } else {
              callback();
            }
          }
        }
      };
    return {
      disabled: true,
      dialogEditFormVisible: false,
      editList: {},
      supplierList: [],
      subTableDataLoading: false,
      subTableData: [],
      detailList: {
        firstName: '',
        secondName: '',
        thirdName: '',
        flashColumn: '',
        type: '',
        filler: '',
        fillerEn: '',
        innerDiameter: '',
        length: '',
        flowRate: '',
        flowRateMax: '',
        cv: '',
        pressure: '',
        weight: '',
        loadAmountMin: '',
        loadAmountMax: '',
        equilibriumVolume: '',
        count: '',
        showApp: '',
        companyType: '',
        units: '',
        thirdCatalogueId: '',
        particleSize: '',
        aperture: '',
        recommendWeight: '',
        trailingFactorMin: '',
        trailingFactorMax:'',
        effectivePedals: '',
        resolution: '',
        supplierId: '',
        author: '',
        status: '',
        columnBedSize: '',
      },
      rules: {
        flashColumn: [
          { validator: flashColumn, trigger: 'blur' },
          { required: true, message: '请输入分离柱名称', trigger: 'blur' },
        ],
        filler: [
          { validator: filler, trigger: 'blur' }
        ],
        innerDiameter: [
          { validator: innerDiameter, trigger: 'blur' }
        ],
        cv: [
          { validator: cv, trigger: 'blur' },
          { required: true, message: '请输入柱体积', trigger: 'blur' },
        ],
        length: [
          { validator: length, trigger: 'blur' }
        ],
        weight: [
          { validator: weight, trigger: 'blur' }
        ],
        loadAmountMin: [
          { validator: loadAmount, trigger: 'blur' }
        ],
        loadAmountMax: [
          { validator: loadAmount, trigger: 'blur' }
        ],
        pressure: [
          { validator: pressure, trigger: 'blur' },
          { required: true, message: '请输入最大耐压', trigger: 'blur' },
        ],
        flowRate: [
          { validator: flowRate, trigger: 'blur' },
          { required: true, message: '请输入最小流速', trigger: 'blur' },
        ],
        flowRateMax: [
          { validator: flowRate, trigger: 'blur' },
          { required: true, message: '请输入最大流速', trigger: 'blur' },
        ],
        equilibriumVolume: [
          { validator: equilibriumVolume, trigger: 'blur' },
        ],    
        aperture: [
          { validator: aperture, trigger: 'blur' }
        ],
        columnBedSize: [
          { validator: columnBedSize, trigger: 'blur' }
        ],
        trailingFactorMax: [
          { validator: trailingFactor, trigger: 'blur' }
        ],
        trailingFactorMin: [
          { validator: trailingFactor, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择正反相柱', trigger: 'change' },
        ],
        effectivePedals: [
          { pattern: /^[0-9]*$/, message: '请输入数字', trigger: 'blur' },
        ],
        resolution: [
          { validator: equilibriumVolume, trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.getDetailList()
    this.getSupplierList()
    setTimeout(() => {
      this.detailList.firstName = this.$store.state.rows.firstName
      this.detailList.secondName = this.$store.state.rows.secondName
      this.detailList.thirdName = this.$store.state.rows.thirdName
      this.detailList.author = this.$store.state.userId
      this.detailList.thirdCatalogueId = this.$store.state.rows.thirdId
    }, 10)
  },
  methods: {
    handlePublish(row) {
      this.$confirm('确定公开该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/updateFlashInfoStatus', [row.id], (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '公开失败!',
                })
                return
              }
              this.$message({
                type: 'success',
                message: '公开成功!',
              })
              this.getDetailList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消公开',
          })
        })
    },
    handleEditDetail(row) {
      this.disabled = false
      this.dialogEditFormVisible = true
      // 对象合并
      this.editList = Object.assign(JSON.parse(JSON.stringify(row)), this.$store.state.rows)
    },
    handleDetail(row) {
      this.disabled = true
      this.dialogEditFormVisible = true
      // 对象合并
      this.editList = Object.assign(JSON.parse(JSON.stringify(row)), this.$store.state.rows)
    },
    supplierName(id) {
      if (!id) {
        return '---'
      } else {
        if (this.supplierList.find(item => item.id === id)) {
          return this.supplierList.find(item => item.id === id).supplierName       
        } else {
          return '---'
        }
      }
    },
    getMaxPressure(val) {
      // 保留小数点后两位
      return (val * 0.06894757).toFixed(2)
    },
    getSupplierList () {
      this.$api.post('/datacenter/getSupplierList', {}, (res) => {
        if(res.data) {
          if(res.data.code !== 200) {
            this.$message({
              type: 'error',
              message: '获取供应商列表失败!',
            })
            return
          }
          this.supplierList = res.data.data
        }
      }) 
    },
    getDetailList() {
      this.subTableDataLoading = true
      this.$api.post('/datacenter/getFlashList', {thirdCatalogueId: this.$store.state.rows.thirdId,author: this.$store.state.userId,supplierId: this.$store.state.supplierId}, (res) => {
        if(res.data) {
          if(res.data.code !== 200) {
            this.$message({
              type: 'error',
              message: '获取子规格失败!',
            })
            return
          }
          this.subTableData = res.data.data
          this.subTableDataLoading = false    
        }
        }) 
    },
    handleDeleteFlashInfoById(row) {
      this.$confirm('确定删除该条数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteFlashInfoById', [row.id], (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '删除失败!',
                })
                return
              }
              this.$message({
                type: 'success',
                message: '删除成功!',
              })
              this.getDetailList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    tableHeaderCellStyle() {
      return 'background-color: #f5f5f5'
    },
    save(formName) {
      this.editList.status = 0
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/updateFlashInfoById', this.editList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '保存失败!',
                })
                return
              }
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetEditForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
    },
    addSave(formName) {
      console.log(this.detailList)
      if(Number(this.detailList.flowRateMax)<Number(this.detailList.flowRate)){
        this.$message({
              type: 'error',
              message: '最大流速必须大于最小流速',
            })
      }else if(this.detailList.trailingFactorMin!=""&&this.detailList.trailingFactorMax!=""){
        if(Number(this.detailList.trailingFactorMin)>Number(this.detailList.trailingFactorMax)){
         this.$message({
                  message: '拖尾因子最大值必须大于最小值',
                  type: 'error'
                })
        }else{
  this.detailList.status = 0
       this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/insertFlashInfo', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: res.data.msg,
                })
                return
              }
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
        }
      }else{
        this.detailList.status = 0
       this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/insertFlashInfo', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: res.data.msg,
                })
                return
              }
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
      }
      
    },
    addRelease(formName) {
       if(Number(this.detailList.flowRateMax)<Number(this.detailList.flowRate)){
         this.$message({
                  message: '最大流速必须大于最小流速',
                  type: 'error'
                })
      }else if(this.detailList.trailingFactorMin!=""&&this.detailList.trailingFactorMax!=""){
  if(Number(this.detailList.trailingFactorMin)>Number(this.detailList.trailingFactorMax)){
         this.$message({
                  message: '拖尾因子最大值必须大于最小值',
                  type: 'error'
                })
        }else{
this.detailList.status = 1
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/insertFlashInfo', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: res.data.msg,
                })
                return
              }
              this.$message({
                message: '公开成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
        }
      }else{
this.detailList.status = 1
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/insertFlashInfo', this.detailList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: res.data.msg,
                })
                return
              }
              this.$message({
                message: '公开成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
      }

      
    },
    release(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$api.post('/datacenter/updateFlashInfoById', this.editList, (res) => {
            if(res.data) {
              if(res.data.code !== 200) {
                this.$message({
                  type: 'error',
                  message: '公开失败!',
                })
                return
              }
              this.$message({
                message: '公开成功',
                type: 'success'
              })
              this.getDetailList()
              this.resetEditForm(formName)
            }
          }) 
        } else {
          return false
        }
      })
    },
    resetEditForm(formName) {
      this.dialogEditFormVisible = false
      this.$refs[formName].resetFields()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      setTimeout(() => {
      this.detailList.firstName = this.$store.state.rows.firstName
      this.detailList.secondName = this.$store.state.rows.secondName
      this.detailList.thirdName = this.$store.state.rows.thirdName
      this.detailList.author = this.$store.state.userId
      this.detailList.thirdCatalogueId = this.$store.state.rows.thirdId
    }, 10)
    },
  },
}
</script>

<style scoped>
.el-table .el-table__cell {
  text-align: center !important;
}
::v-deep .el-pagination__jump {
  margin-left: 0 !important;
}
::v-deep .top-tab .text-left {
  font-size: 14px;
}
::v-deep .top-tab .text-right {
  font-size: 20px;
  font-weight: 700;
}
::v-deep .top-tab .text-middle {
  margin: 0 15px;
}
::v-deep .top-tab {
  margin-bottom: 30px;
}
::v-deep .deep-box {
  background-color: #f5f5f5;
  padding-top: 23px;
  margin-bottom: 43px;
  box-sizing: border-box;
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
  margin-bottom: 20px;
}
::v-deep .el-dialog--center {
  height: auto;
  width: auto;
  max-height: 800px;
  overflow-y: auto;
  max-width: 820px;
  overflow-x: auto;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .el-link--inner {
  display: flex;
  align-items: center;
}
::v-deep .el-input input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
